import { L10nModule } from 'bernie-l10n';

export const localization = (locale: string): L10nModule => {
  const mod = new L10nModule();

  mod.current = locale;
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  mod.globalize = require(`flights-shopping-pwa-localization/dist/bundle-${locale}`);

  return mod;
};
